<template>
    <html>
    <body style="position: relative;background: #fff" v-loading="loading">
        <!--主体开始-->
        <div class="nding">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/agricultural/index">农技服务</a>&gt;<a href="">农技专家</a>
            </div>
        </div>
        <div class="fenlei">

            <div class="xia1">
                <ul>
                    <h4>排序方式</h4>
                    <div>
                        <li>
                            <a href="javascript:void(0)" @click="orderby('')" :class="order == '' ? 'on' : ''">
                                默认排序
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0)" @click="orderby('askCount desc')" :class="order == 'askCount desc' ? 'on' : ''">
                                咨询量从高到低
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0)" @click="orderby('answerCount desc')" :class="order == 'answerCount desc' ? 'on' : ''">
                                回复量从高到低
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0)" @click="orderby('answerrate desc')" :class="order == 'answerrate desc' ? 'on' : ''">
                                回复率从高到低
                            </a>
                        </li>
                    </div>
                </ul>
                <ul>
                    <h4>研究领域</h4>
                    <div>
                        <li v-for="item in typelist" :key="item.id"><a :class="field == item.tid ? 'on' : ''" href="javascript:void(0)" @click="changeField(item.tid)">{{item.typename}}</a></li>
                    </div>
                </ul>
            </div>
        </div>
        <section class="section container08">
            <div class="tj1">
                <ul class="zhuanjia">
                    <li v-for="item in expertPage" :key="item.id">
                        <div class="sh">
                            <div class="z"><img :src="$util.img(item.image)" alt=""></div>
                            <div class="y">
                                <h2>{{item.name}}·{{item.title}} | <a :href="'/agricultural/expertdetails?id='+item.id">详情</a></h2>
                                <p>{{item.unit}}</p>
                            </div>
                        </div>
                        <div class="zh">
                            <h2>{{item.askCount}} <span>咨询量</span></h2>
                            <h2>{{item.answer_rate}}<span>回复率</span></h2>
                        </div>
                        <div class="xia">擅长：{{item.expert_in}}</div>
                        <a :href="'/agricultural/expertdetails?id='+item.id" class="btn">免费提问</a>
                    </li>
                </ul>
            </div>
        </section>
        <div class="pages">
            <div class="Pagination"></div>
            <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
        </div>
    </body>
</html>
</template>

<script>
    import '@/assets/styles/js/jquery.pagination.js';
    import { expertPage } from '@/api/expert/expert';
    import { publictypeList } from '@/api/publicType/publicType';

    export default {
        name: 'expertlist',
        components: {},
        data: () => {
            return {
                loading: true,
                expertPage:[],
                pageCount:0,
                page_size:10,
                page:1,
                typelist:[],
                field:'',
                order:'',
            };
        },
        created() {
            //this.field = this.$route.query.field;
            this.getexpertPage();
            this.gettypelist();
        },

        methods: {
            getexpertPage() {
                expertPage({
                    page_size: this.page_size,
                    page: this.page,
                    field: this.field,
                    order: this.order
                }).then(res => {
                    if(res.code == 0) {
                        this.pageCount = res.data.page_count;
                        $(".Pagination").pagination(this.pageCount, {
                            callback: this.changepage
                        });
                        $(".allPage").text(this.pageCount);
                        this.expertPage = res.data.list;
                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err.message);
                });
            },
            gettypelist() {
                publictypeList({
                    typenumber: "10004",
                    level: 2
                }).then(res => {
                    if(res.code == 0) {
                        this.typelist = res.data;
                    }
                })
            },
            changepage(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                expertPage({
                    page_size: this.page_size,
                    page: this.page,
                    field: this.field,
                    order: this.order
                }).then(res => {
                    if(res.code == 0) {
                    this.expertPage = res.data.list;
                    console.log(this.expertPage);
                    this.loading = false;
                    }
                });
            },
            orderby(sort) {
                this.order = sort;
                this.getexpertPage();
            },
            changeField(tid) {
                this.field = tid;
                this.getexpertPage();
            }
        }

    }
</script>
